import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 18C11.701 18 11.4326 17.8688 11.2494 17.6608L7.29042 13.7076C6.89989 13.317 6.89984 12.6781 7.29036 12.2875C7.68089 11.897 8.31984 11.897 8.71037 12.2876L10.9999 14.5804L10.9999 2C10.9999 1.44771 11.4477 1 11.9999 1C12.5522 1 12.9999 1.44772 12.9999 2L12.9999 14.5805L15.2895 12.2876C15.6801 11.8971 16.319 11.897 16.7096 12.2875C17.1001 12.6781 17.1001 13.317 16.7095 13.7075L12.7501 17.6613C12.5668 17.869 12.2987 18 11.9999 18Z M3 8C1.89543 8 1 8.89543 1 10V21C1 22.1046 1.89543 23 3 23H21C22.1046 23 23 22.1046 23 21V10C23 8.89543 22.1046 8 21 8H17C16.4477 8 16 8.44771 16 9C16 9.55229 16.4477 10 17 10H21V21H3V10H7C7.55228 10 8 9.55229 8 9C8 8.44771 7.55228 8 7 8H3Z"
  }));
});
var PaymentRefund = AbstractIcon.withComponent(Icon);
PaymentRefund.displayName = 'PaymentRefund';
export default PaymentRefund;